import { RootState } from "@/store/store";
import { providerConnectionsStateSelector } from "@/store/provider-connections/selectors/providerConnectionsStateSelector";

export const providerConnectionsDrawerOpenSelector = (
  state: RootState,
): boolean => {
  return !!providerConnectionsStateSelector(state).activeProviderConnection
    .type;
};
